import create from 'zustand';

interface UseConfirmationModalType {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  title: string | null;
  setTitle: (newTitle: string | null) => void;
  hideStatusUpdateText: boolean;
  setHideStatusUpdateText: (newNPFreeze: boolean) => void;
}

const useConfirmationModal = create<UseConfirmationModalType>()((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false, title: null }),
  title: null,
  setTitle: (newTitle: string | null) => set({ title: newTitle }),
  hideStatusUpdateText: false,
  setHideStatusUpdateText: (newHideStatusUpdateText: boolean) => set({ hideStatusUpdateText: newHideStatusUpdateText }),
}));

export default useConfirmationModal;
